import React from 'react'
import { Dropdown, Grid } from 'semantic-ui-react'
import { skipColum, sortColumnNames } from '../../utilities/columnNames'
import { findMappingByColumn, getColumnHeadersFromWorksheet } from '../../utilities/worksheet'

export default function FieldsMappingForm({
  excelRows,
  mappings,
  columns,
  onAddMapping,
}) {
  return (
    <Grid>
      <Grid.Row columns={1}>
        <Grid.Column>
          <Grid>
            <Grid.Row columns={2} key='-1'>
              <Grid.Column>
                <b>Input Column</b>
              </Grid.Column>
              <Grid.Column>
                <b>Match</b>
              </Grid.Column>
            </Grid.Row>

            {getColumnHeadersFromWorksheet(excelRows).map((colName, idx) => {
              const sortedColumns = [skipColum, ...sortColumnNames(columns, colName)]
              return (
                <Grid.Row columns={2} key={idx + colName}>
                  <Grid.Column>
                    <div>{colName}</div>
                  </Grid.Column>
                  <Grid.Column>
                    <Dropdown
                      placeholder='Select Field'
                      fluid selection
                      options={sortedColumns}
                      value={findMappingByColumn(colName, mappings)}
                      onChange={(_, { value }) => onAddMapping(colName, value)} />
                  </Grid.Column>
                </Grid.Row>
              )
            }
            )}
          </Grid>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  )
}



// WEBPACK FOOTER //
// ./components/create-order/FieldsMappingForm.js